import React from "react";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const Label = ({
  children,
  htmlFor,
  className = "",
  sx = {},
  ...props
}) => {
  const theme = useTheme();

  // Manejo de clases CSS personalizadas para compatibilidad
  const parseCustomClasses = (className) => {
    const customStyles = {};

    if (className.includes("text-sm")) {
      customStyles.fontSize = "0.875rem";
    }
    if (className.includes("font-medium")) {
      customStyles.fontWeight = 500;
    }
    if (className.includes("mb-2")) {
      customStyles.marginBottom = "8px";
    }
    if (className.includes("block")) {
      customStyles.display = "block";
    }
    if (className.includes("text-xs")) {
      customStyles.fontSize = "0.75rem";
    }
    if (className.includes("text-muted-foreground")) {
      customStyles.color = theme.palette.text.secondary;
    }
    if (className.includes("flex")) {
      customStyles.display = "flex";
    }
    if (className.includes("items-center")) {
      customStyles.alignItems = "center";
    }
    if (className.includes("gap-2")) {
      customStyles.gap = "8px";
    }

    return customStyles;
  };

  const customStyles = parseCustomClasses(className);

  return (
    <Typography
      component="label"
      htmlFor={htmlFor}
      sx={{
        fontSize: "0.875rem",
        fontWeight: 500,
        color: theme.palette.text.primary,
        cursor: htmlFor ? "pointer" : "default",
        ...customStyles,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
};
